export async function saveBlockToDb(blockData) {
    const response = await fetch('https://html-creator.demo.cartago.com/api/save-block', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(blockData),
    });
    const result = await response.json();
    console.log(result.message);
  }